/**
 * Cierre Contable API Service
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const cierreContableService = {
  getAll: (filters = {}) => api.get(`${API_BASE_URL}/cierres-periodo/`, { params: filters }),
  getById: (id) => api.get(`${API_BASE_URL}/cierres-periodo/${id}/`),
  create: (data) => api.post(`${API_BASE_URL}/cierres-periodo/`, data),
  update: (id, data) => api.patch(`${API_BASE_URL}/cierres-periodo/${id}/`, data),
  delete: (id) => api.delete(`${API_BASE_URL}/cierres-periodo/${id}/`),
  preview: (id) => api.get(`${API_BASE_URL}/cierres-periodo/${id}/preview/`),
  ejecutar: (id) => api.post(`${API_BASE_URL}/cierres-periodo/${id}/ejecutar/`),
  reabrir: (id) => api.post(`${API_BASE_URL}/cierres-periodo/${id}/reabrir/`),
};

export default cierreContableService;
